import { Api, ApiResponse } from './api';

export type UserLoginResponse = {
    result: boolean;
    error: string|null;
    username: string|null;
    userid: number;
}

export type UserTokenResponse = {
    expires: number;
    token: string;
}

export type UserCSRFResponse = {
    name: string;
    value: string;
}

export type UserResetResponse = {
    data: object;
    msg: string;
    message: 'username-required'|'reset-sent';
    messageType?: 'danger'|'success';
    result: boolean;
    error: string;
}

export class UserApi {
    constructor(public readonly url: string, private readonly api: typeof Api) {}

    // endpoints:
    // POST api/auth/strategy
    // POST api/auth/reset
    // GET api/auth/totp_qrcode
    // POST api/auth/totp_validate
    // POST api/auth/test_email

    async login(data: {username: string, [key: string]: unknown}) {
        // using fetch, as api_post would get a token
        const response = await fetch(`${this.url}/api/auth/login`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: await Api.add_csrf_header(new Headers({ 'Content-Type': 'application/json' }), 'POST'),
        });
        const json = await response.json();
        return json as ApiResponse<UserLoginResponse>;
    }

    async token() {
        const response = await fetch(`${this.url}/api/auth/token`, {
            method: 'POST',
            body: null,
            headers: await Api.add_csrf_header(new Headers({ 'Content-Type': 'application/json' }), 'POST'),
        });
        const json = await response.json();
        return json as ApiResponse<UserTokenResponse>;
    }

    async csrf() {
        const response = await fetch(`${this.url}/api/auth/csrf`, {
            method: 'POST',
            body: null,
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        const json = await response.json();
        return json as ApiResponse<UserCSRFResponse>;
    }

    async strategies(username: string) {
        return Api.api_post<string[]>(`${this.url}/api/auth/strategy`, { username });
    }

    async reset(usernameOrEmail: string) {
        return Api.api_post<UserResetResponse>(`${this.url}/api/auth/reset`, { username: usernameOrEmail });
    }

    /**
     * not implemented
     */
    async totp_qrcode() {}

    async totp_validate(otp: number, credential: string) {
        return Api.api_post<'otp validated'>(`${this.url}/api/auth/totp_validate`, { otp, credential });
    }

    async status() {
        return Api.api_get<{username: string}>(`${this.url}/api/auth/status`);
    }

    /**
     * not implemented
     */
    async email_test() {}
}
